<template>
  <div class="disableFor">
    <div class="question">{{$t('promotions.disable_for')}}</div>
    <ToggleSwitch v-model="disableFor.takeout">{{$t('deliveryMethod.takeout')}}</ToggleSwitch>
    <ToggleSwitch v-model="disableFor.delivery">{{$t('deliveryMethod.delivery')}}</ToggleSwitch>
  </div>
</template>

<script>
import ToggleSwitch from "@/components/tools/ToggleSwitch";

export default {
  name: "PromotionDisableFor",

  components: { ToggleSwitch },

  props: {
    disableFor: Object
  }
}
</script>